import styled from "styled-components";

export const Input = styled.input`
  display: block;
  border: 1px solid var(--background);
  background: #fff;
  border-radius: 5px;
  font-family: var(--fontFamily);
  padding: 16px;
  font-size: 16px;
  width: auto;
  width: 100%;
  height: 55px;
  &::placeholder {
    color: hsla(var(--backgroundHSL), 0.6);
  }
`;
